const Placeholder = ({ userInfo, user, ...props })=>{
    return (
        <div>Placeholder</div>
    )
}

export default Placeholder